import type { ProjectGroup } from '@/deploy/types';
import styles from './GroupBadge.module.scss';

interface GroupBadgeProps {
  group: Pick<ProjectGroup, 'label' | 'color'>;
  size?: 'sm' | 'md';
  title?: string;
}

/**
 * Drapeau d'un groupe de jeu (Nova, Iris...), calqué sur EnvBadge : la couleur du groupe passe
 * par la variable CSS --group-color, ton neutre si le groupe n'en a pas.
 */
export function GroupBadge({ group, size = 'sm', title }: GroupBadgeProps) {
  return (
    <span
      className={[styles.groupBadge, styles[`size_${size}`]].join(' ')}
      style={group.color ? { ['--group-color' as string]: group.color } : undefined}
      title={title}
    >
      <span className={styles.dot} />
      <span className={styles.name}>{group.label}</span>
    </span>
  );
}
